import registerCustomPdfFonts from '@src/app/modules/components/pdf/fonts';

let isInitialized = false;

const initializeApp = () => {
  if (!isInitialized) {
    // ** initializer functions here
    registerCustomPdfFonts();
    isInitialized = true;
  }
};

export default initializeApp;
